(function () {
    'use strict';

    angular
     .module('oddQuestionnaireTemplateModule')
     .directive('oddQuestionnaireTemplateSection', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addSection = '&?';
        directiveScope.editSectionList = '&?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
             function ($rootScope, $scope, $controller) {

                 // Box Template
                 $scope.baseTemplatePath = '/app/shared/odd/questionnaireTemplate/oddQuestionnaireTemplateSection.[Template].tpl.html';
                 $controller('BoxTmplController', {
                     $scope: $scope
                 });

                 $scope.goToSection = function (qTemplateSection) {
                     $scope.clickOnBox({
                         questionnaireTemplateSection: qTemplateSection
                     });
                 };

                 $scope.initNavItem = function (section) {
                     if (section.ConditionalODDQuestionID) {
                         section.ConditionalODDSection = _.find($scope.boxContext.ODDSections, {
                             ODDSectionID: section.ConditionalODDQuestion.ODDSectionID
                         });
                     }
                 }

             }
            ],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();